<template>
    <div class="e6-select-dynamic">
        <el-select v-model="myValue" clearable filterable :loading="loading">
            <el-option v-for="item in selectData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
    </div>
</template>

<script>
    import request from "_private/utils/request";

    export default {
        name: "E6SelectDynamic",
        props: {
            dynamicApi: {
                type: Object,
                default: function () {
                    return {
                        url: "",
                        method: "",
                        key: ""
                    };
                }
            },
            value: {
                default: ""
            }
        },
        data() {
            return {
                selectData: [],
                loading: false,
                apiConfig: {},
                myValue: ""
            };
        },
        watch: {
            myValue(val) {
                this.$emit("update:value", val);
            }
        },
        created() {
            if (!this.dynamicApi.url) {
                throw "url is empty!";
            }
            if (!this.dynamicApi.method) {
                throw "method is empty!";
            }
            this.FetchData(this.dynamicApi);
            this.myValue = this.value;
        },
        methods: {
            FetchData(dynamicApi) {
                this.apiConfig = {
                    url: dynamicApi.url,
                    method: dynamicApi.method
                };
                this.loading = true;
                return request(this.apiConfig)
                    .then(response => {
                        this.loading = false;
                        this.selectData = response.result;
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error);
                    });
            }
        }
    };
</script>
